import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useT } from "../i18n";
import BottomNav from "../components/BottomNav";
import { ShoppingBag, RotateCcw } from "lucide-react";

export default function Suggestions() {
  const { t } = useT();
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  const load = async () => {
    try {
      const r = await api.get("/suggestions");
      setItems(r.data.suggestions || []);
    } catch (_e) { toast.error(t("common.error")); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const repurchase = async (s) => {
    const d = new Date();
    d.setDate(d.getDate() + 7);
    const iso = d.toISOString().slice(0, 10);
    try {
      await api.post("/items", { product_name: s.product_name, expiry_date: iso, quantity: 1 });
      toast.success(t("dashboard.toast.created_in", { group: t("dashboard.group.green") }));
      navigate("/dashboard");
    } catch (e) {
      const detail = e?.response?.data?.detail || "";
      const m = /^plan_limit:max_items:(\d+)$/.exec(detail);
      if (m) toast.error(t("plan.limit.items", { n: m[1] }));
      else toast.error(t("dashboard.toast.create_failed"));
    }
  };

  return (
    <div className="min-h-screen bg-white pb-32" data-testid="suggestions-page">
      <header className="pt-safe pt-10 px-6">
        <div className="text-[11px] tracking-[0.2em] uppercase font-bold text-fresh-green-text">{t("sugg.eyebrow")}</div>
        <h1 className="mt-2 font-heading text-4xl font-medium tracking-tight leading-tight">{t("sugg.title")}</h1>
        <p className="mt-3 text-zinc-500 text-sm">{t("sugg.subtitle")}</p>
      </header>

      <section className="mt-8" data-testid="suggestions-list">
        {items.length === 0 && (
          <div className="px-6 mt-6 rounded-3xl bg-zinc-50 border border-zinc-100 py-10 text-center">
            <ShoppingBag className="w-8 h-8 mx-auto text-zinc-400" />
            <h3 className="mt-4 font-heading text-xl font-medium">{t("sugg.empty")}</h3>
          </div>
        )}
        {items.map((s) => (
          <div key={s.product_name} className="flex items-center justify-between px-6 py-5 border-b border-zinc-100" data-testid={`suggestion-${s.product_name}`}>
            <div className="flex-1 min-w-0">
              <div className="font-heading text-lg font-medium truncate opacity-70">{s.product_name}</div>
              <div className="text-[11px] text-zinc-400 uppercase tracking-widest font-bold mt-0.5">× {s.times_consumed}</div>
            </div>
            <button
              onClick={() => repurchase(s)}
              className="px-4 py-2 rounded-full bg-zinc-950 text-white text-sm font-medium flex items-center gap-2 active:scale-95"
              data-testid={`repurchase-btn-${s.product_name}`}
            >
              <RotateCcw className="w-4 h-4" /> {t("sugg.add_again")}
            </button>
          </div>
        ))}
      </section>

      <BottomNav />
    </div>
  );
}
